module.exports = __webpack_public_path__ + "img/memberlist-active.144e534e.svg";